export default "__VITE_ASSET__B5rNY4D6__"